import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardSectionElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Section } from "@easy-email-pro-core/components/Elements";
import { cloneDeep } from "lodash";

import { Section as SourceElement } from "../../basic/Section";

const defaultData: ElementDefinition<StandardSectionElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {
      "vertical-align": "top",
      "background-repeat": "no-repeat",
      "border-width": "1px",
      "border-style": "solid",
      "border-color": "#AAAAAA",
    },
    data: {},
  });

export const StandardSection = createBlock<StandardSectionElement>({
  get name() {
    return t("Section");
  },
  defaultData,
  type: StandardType.STANDARD_SECTION,
  create: (payload) => {
    const defaultData: StandardSectionElement = {
      type: StandardType.STANDARD_SECTION,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SECTION,
  render(params) {
    const { node } = params;

    const cloneAttributes = cloneDeep(node.attributes);

    const {
      "border-enabled": borderEnabled,
      "border-width": borderWidth,
      "border-style": borderStyle,
      "border-color": borderColor,
      "vertical-align": verticalAlign = "top",
      ...attributes
    } = cloneAttributes;

    if (!attributes["background-image-enabled"]) {
      delete attributes["background-image-enabled"];
      delete attributes["background-url"];
      delete attributes["background-position"];
      delete attributes["background-position-x"];
      delete attributes["background-position-y"];
      delete attributes["background-repeat"];
      delete attributes["background-size"];
    }

    const border = borderEnabled
      ? `${borderWidth || "1px"} ${borderStyle || "solid"} ${
          borderColor || "#AAAAAA"
        }`
      : "";

    return (
      <Section
        padding="0px"
        idx={params.idx}
        {...attributes}
        border={border}
        data={node.data}
        children={params.children || node.children}
      ></Section>
    );
  },
});
